module.exports = __webpack_public_path__ + "8b9c338bf4bcadd9440a1228e4897d4f.jpg";